import script from "./DisplayRange.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisplayRange.vue?vue&type=script&lang=ts&setup=true"

import "./DisplayRange.vue?vue&type=style&index=0&id=af0f6684&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af0f6684"]])

export default __exports__